import angular from 'angular';
import DynamicBannerComponent from './dynamic-banner.component';

let DynamicBannerModule = angular.module('shared.components.banners.dynamicBanner', [])
  .component('dynamicBanner', DynamicBannerComponent);

export default DynamicBannerModule;



// WEBPACK FOOTER //
// ./www/components/shared/components/banners/dynamic-banner/dynamic-banner.js